import PasswordResetFlow from "../components/PasswordResetFlow";

export default function ForgotPasswordPage() {
  return <PasswordResetFlow />;
}
